import * as React from "react";
import * as ReactDOM from "react-dom";
import timestamp from "../Utils/timestamp";

export interface TimestampProps
    extends React.Props<TimestampControl> {
    time: Date;
}

let timestamps: TimestampControl[] = [];
let interval: number = undefined;

function watchTimestamp(control: TimestampControl): void {
    timestamps.push(control);
    if (_.isUndefined(interval)) {
        interval = setInterval(() => {
            timestamps.forEach(x => x.forceUpdate());
        }, 30000); 
    }
}

function unwatchTimestamp(control: TimestampControl): void {
    timestamps = timestamps.filter(x => x != control);
    if (!timestamps.length) {
        if (!_.isUndefined(interval)) {
            clearInterval(interval);
            interval = undefined;
        }
    }
}

export class TimestampControl extends React.Component<TimestampProps, any> {
    private span: HTMLSpanElement;

    constructor(props: TimestampProps) {
        super(props);
    }

    public componentDidMount() {
        watchTimestamp(this);
    }

    public componentWillUnmount() {
        unwatchTimestamp(this);
    }

    public render(): JSX.Element {
        return (
            <span ref={x => this.span = x}>{timestamp(this.props.time)[0]}</span>
            ); 
    }
}


// WEBPACK FOOTER //
// ./../Intercom.ReactUI/Views/TimestampControl.tsx